import ControllerBase from 'global/js/ControllerBase';

interface ComponentRefs {
	navButton: 'navButton';
	navbarWrapper: 'navbarWrapper'
}

export default class ControllerProfessionalAnchorNavigation extends ControllerBase<ComponentRefs> {
	private button: HTMLAnchorElement;
	private anchorNav: HTMLDivElement;

	constructor(element: HTMLElement) {
		super(element);
		this.button = this.$references.navButton as HTMLAnchorElement;
		this.anchorNav = this.$references.navbarWrapper as HTMLDivElement;

		this.button &&
			this.button.addEventListener('click', (e) => {
				e.preventDefault();
				this.button.classList.toggle('is-active');
			});

		this.init();
	}

	private init() {
		this.detectScrollDirection();
	}

	private detectScrollDirection() {
		let oldValue: number;
		let newValue: number;

		window.addEventListener('scroll', () => {
			newValue = window.scrollY;

			oldValue > newValue
				? this.anchorNav.classList.add('up')
				: this.anchorNav.classList.remove('up')

			oldValue = newValue
		})

	}
}
